import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import AppStoreBadgeImage from '@assets/appstore-badge.png';
import GooglePlayBadgeImage from '@assets/google-play-badge.png';
import { PAGE_TYPE } from '../..';
import JetButton from '@src/shared/components/JetButton';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useScroll } from '@src/shared/hooks/use-scroll';
import { Trans, useTranslation } from 'react-i18next';
const BottomActionContent = (props: any) => {
  const classes = useStyles();
  const { isResolutionMobile } = useDeviceDetect()
  const { scrollTop, scrollHeight } = useScroll()
  const [reachedFixedThreshold, setReachedFixedTreshold] = useState(false)
  const TRESHOLD_LIMIT = isResolutionMobile ? 296 : 72
  const { t } = useTranslation()
  const calculateFixTreshold = () => {
    if (scrollHeight && scrollTop >= (scrollHeight as number - TRESHOLD_LIMIT)) {
      setReachedFixedTreshold(true)
    } else if (reachedFixedThreshold) {
      setReachedFixedTreshold(false)
    }
  }
  useEffect(()=> {
    calculateFixTreshold()
  },[scrollTop])

  useEffect(()=> {
    calculateFixTreshold()
  }, [])

  const handleAction = () => {
    if (props.pageType === PAGE_TYPE.MANAGER) {
      props.onAction()
    } else if (props.pageType === PAGE_TYPE.COURIER) {
      props.onAutoDetectDownload()
    }
  }


  return (
    <div className={`${classes.bottomActionContent} ${reachedFixedThreshold ? 'fix-treshold' : '' }`}>
      <Typography
        variant={isResolutionMobile ? "caption" : "body1"}
        className={`${isResolutionMobile ?  'caption' : 'subheading_l'} bottom-action-content-text`}
      >
        <Trans i18nKey="new_productoverview_common.section9_slogan" components={{ strong: <strong /> }} />
      </Typography>
      <div className='bottom-action-content-cta'>
        {isResolutionMobile ? (
          <JetButton onClick={handleAction} size={isResolutionMobile ? 'xsmall' : 'large'} variation="primary">
            {props.pageType === PAGE_TYPE.MANAGER ? t('new_productoverview_manager.common_get_started_button') :  t('new_productoverview_courier.common_download_now_button') }
          </JetButton>
        ) : (
          (props.pageType === PAGE_TYPE.COURIER ? <div className='bottom-action-content-store-link-container'>
            <img src={AppStoreBadgeImage} onClick={props.onIosDownload} />
            <img src={GooglePlayBadgeImage} onClick={props.onAndroidDownload} />
          </div> : <JetButton onClick={props.onAction} size={'large'} variation="primary">
            {t('new_productoverview_manager.common_get_started_button')}
          </JetButton>)
        )}
      </div>
    </div>
  );
};

export default BottomActionContent;
